<template>
  <ConfirmBusiness />
</template>

<script>
  import ConfirmBusiness from '../../components/forms/auth/ConfirmBusiness';

  export default {
    components: {
      ConfirmBusiness,
    },
    metaInfo() {
      return {
        title: this.$t('views_register_title'),
      };
    },
  };
</script>
